import { render, staticRenderFns } from "./ServicesAutocomplete.vue?vue&type=template&id=bce73db2&scoped=true"
import script from "./ServicesAutocomplete.vue?vue&type=script&lang=js"
export * from "./ServicesAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce73db2",
  null
  
)

export default component.exports